const events = [
  {
    name: "North Star Regional",
    month: "April",
    date: "1-4",
    location: "University of Minnesota",
    year: "2025",
  },
  {
    name: "10,000 Lakes Regional Competition",
    month: "March",
    date: "26-29",
    location: "MN State Fairgrounds",
    year: "2025",
  },
  {
    name: "Asian Fair",
    month: "May",
    date: "31",
    location: "Hilde Performance Center",
    year: "2025",
  },
  {
    name: "Plymouth on Parade",
    month: "Sep",
    date: "",
    location: "Plymouth, MN",
    year: "2025",
  },
  {
    name: "James J. Hill Days",
    month: "Sep",
    date: "5-7",
    location: "Downtown Wayzata",
    year: "2025",
  },
];

export default events;

